export enum Route {
  ActivateAccount,
  BoxCreate,
  BoxQuestionnaireDetails,
  BoxQuestionnaires,
  BoxSaleDetails,
  BoxSaleDetailsFromBoxes,
  BoxSaleEdit,
  BoxSales,
  BoxSaleBoxDetails,
  BoxDetails,
  BoxEdit,
  Boxes,
  BrandCreate,
  BrandDetails,
  BrandEdit,
  Brands,
  Companies,
  CompanyCreate,
  CompanyDetails,
  CompanyEdit,
  CosmeticCreate,
  CosmeticDetails,
  CosmeticEdit,
  Cosmetics,
  Dashboard,
  DictionaryBoxCategoryCreate,
  DictionaryBoxCategoryEdit,
  DictionaryBoxCategoryList,
  DictionaryCountryCreate,
  DictionaryCountryEdit,
  DictionaryCountryList,
  DictionaryList,
  DictionaryProductAttributeCreate,
  DictionaryProductAttributeEdit,
  DictionaryProductAttributeList,
  Forbidden,
  Invoices,
  Loading,
  Multimedia,
  MultimediaDetailsFromGrid,
  MultimediaDetailsFromList,
  MultimediaGridView,
  MultimediaListView,
  MultimediaUpload,
  NotFound,
  OrderDetails,
  OrderPartialRefund,
  Orders,
  PL_Account,
  PL_AccountAddresses,
  PL_AccountBeautyProfile,
  PL_AccountDetails,
  PL_AccountOrderDetails,
  PL_AccountOrders,
  PL_AccountQuestionnaireDetails,
  PL_AccountQuestionnaires,
  PL_AccountSubscriptionDetails,
  PL_AccountSubscriptions,
  PL_BoxDetails,
  PL_BoxDetailsAuthorization,
  PL_Boxes,
  PL_BrandDetails,
  PL_Brands,
  PL_Checkout,
  PL_Contact,
  PL_CosmeticDetails,
  PL_FAQ,
  PL_OrderBox,
  PL_OrderPaymentRedirection,
  PL_OrderSummaryWithToken,
  PL_Payment,
  PL_PrivacyPolicy,
  PL_ProductDetails,
  PL_ProductDetailsAuthorization,
  PL_Products,
  PL_RegulationsOfPublishingOpinions,
  PL_RegulationsOfShop,
  PL_ShoppingCartDetails,
  PageCreate,
  PageDetails,
  PageEdit,
  Pages,
  FaqCategories,
  FaqCategoryDetails,
  FaqCategoryCreate,
  FaqCategoryEdit,
  PaymentMethodDetails,
  PaymentMethodEdit,
  PaymentMethods,
  ProductCreate,
  ProductDetails,
  ProductEdit,
  Products,
  Redirection,
  RemindPassword,
  ResetPassword,
  Root,
  ShippingMethodDetails,
  ShippingMethodEdit,
  ShippingMethods,
  ShopConfig,
  ShopKsefConfiguration,
  ShopRefundSettings,
  ShopShippingSettings,
  ShopValidationSettings,
  ShopCartSettings,
  BackgroundTasks,
  ShopHomeBannerCreate,
  ShopHomeBannerDetails,
  ShopHomeBannerEdit,
  ShopHomeBannerList,
  ShopBannerCreate,
  ShopBannerDetails,
  ShopBannerEdit,
  ShopBannerList,
  ShopSubscribeBannerCreate,
  ShopSubscribeBannerDetails,
  ShopSubscribeBannerEdit,
  ShopSubscribeBannerList,
  SignIn,
  SignOut,
  SignUp,
  SignUpAsClient,
  SignUpAsCompany,
  SubscriptionBulkPriceChange,
  SubscriptionDetails,
  Subscriptions,
  UserCreate,
  UserDetails,
  UserEdit,
  Users,
  Notifications,
  NotificationDetails,
  Warehouse,
  WarehouseLocalizationCreate,
  WarehouseLocalizationEdit,
  WarehouseLocalizations,
  WarehouseOwners,
  WarehouseProductDetails,
  WarehouseProductEdit,
  WarehouseProducts,
  WarehouseReceiptCreate,
  WarehouseReceiptDetails,
  WarehouseReceiptEdit,
  WarehouseReceipts,
  WarehouseReleaseCreate,
  WarehouseReleaseDetails,
  WarehouseReleaseEdit,
  WarehouseReleases,
  WarehouseRestockCreate,
  WarehouseRestockDetails,
  WarehouseRestockEdit,
  WarehouseRestocks,
}
